import { render, staticRenderFns } from "./ChatAside.vue?vue&type=template&id=548ab756&scoped=true&"
import script from "./ChatAside.vue?vue&type=script&lang=ts&"
export * from "./ChatAside.vue?vue&type=script&lang=ts&"
import style0 from "./ChatAside.vue?vue&type=style&index=0&id=548ab756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548ab756",
  null
  
)

export default component.exports